import React from 'react';
import '../css/LoadingAnimation.css'; // Import the CSS file
import truck from '../img/truck.gif'; // Import the image file

export const ActivityIndicator = () => {
    return (
        <div className="loading-container">
            {/* <div className="loader">
                <svg>
                    <circle cx="75" cy="75" r="50"></circle>
                    <circle cx="75" cy="75" r="50"></circle>
                    <circle cx="75" cy="75" r="50"></circle>
                    <circle cx="75" cy="75" r="50"></circle>
                </svg>
            </div> */}
            <img src={truck} alt="Loading..." />
        </div>

    );
};
